import { createFileRoute } from '@tanstack/react-router';
import { MonitoramentoPage } from '../../../monitoramento/monitoramento-page.tsx';

export const Route = createFileRoute('/monitoramento/')({
  component: MonitoramentoPage,
});
